<template>
  <div class="card">
    <div class="grid grid-cols-6 gap-4">

      <div class="col-span-6">
        <label for="mov-name" class="block text-sm font-medium text-gray-700"> Movimiento</label>
        <Dropdown inputId="mov-name" v-model="idDetalle" :options="movimientos" optionLabel="nombre"
          @change="completeInfo" optionValue="idDetalle" placeholder="Seleccione una opción" optionGroupLabel="nombre"
          optionGroupChildren="detalle" class="w-full">
          <template #optiongroup="slotProps">
            <div class="flex align-items-center">
              <i class="pi pi-folder mr-2"></i>
              <div>{{ slotProps.option.nombre }}</div>
            </div>
          </template>
        </Dropdown>
      </div>

      <div class="col-span-6" v-show="idDetalle">

        <div class="grid grid-cols-6 gap-4">

          <div class="col-span-6 sm:col-span-3">
            <label for="monthpicker" class="block text-sm font-medium text-gray-700">Periodo</label>
            <Calendar inputId="monthpicker" v-model="periodo" view="month" dateFormat="yy-mm" />
          </div>

        </div>
        <br />
        <div class="grid grid-cols-6 gap-4">
          <div class="col-span-6 sm:col-span-3">
            <label for="ven1" class="block text-sm font-medium text-gray-700">Fecha Vencimiento 1</label>
            <Calendar inputId="ven1" v-model="fechaVencimiento1" @blur="handleManualChange" />
            <p v-if="mensajeAdvertencia1" style="color: #F59E0B;">¡Ha modificado la fecha de vencimiento 1</p>
          </div>

          <div class="col-span-6 sm:col-span-3">
            <label for="ven2" class="block text-sm font-medium text-gray-700">Fecha Vencimiento 2</label>
            <Calendar inputId="ven2" v-model="fechaVencimiento2" @blur="handleManualChange" />
            <p v-if="mensajeAdvertencia2" style="color: #F59E0B;">¡Ha modificado la fecha de vencimiento 2</p>
          </div>
        </div>
        <br />
        <div class="col-span-6 sm:col-span-3">
          <div class="col-span-6 sm:col-span-8" v-show="ocularImporte">
            <label for="importe-ar" class="block text-sm font-medium text-gray-700">Importe </label>
            <InputNumber inputId="importe-ar" v-model="importe" mode="currency" currency="ARS" locale="es-AR"
              :min="0" />
            <InlineMessage v-if="!!errors.importe">{{ errors.importe }}</InlineMessage>
          </div>
          <br />
          <!-- <div v-show="detalle.cuotas" class="col-span-6 sm:col-span-3"> -->
          <div class="col-span-6 sm:col-span-3" v-show="ocultarCuotas">
            <label for="Cuotas" class="text-sm font-medium text-gray-700">Cuotas </label>
            <InputNumber inputId="Cuotas" v-model="cuotas" showButtons buttonLayout="horizontal" :step="1" :min="1"
              :max="24" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" v-show="!usuarioValido" />
            <InputNumber v-model="cuotas" showButtons buttonLayout="horizontal" :step="1" :min="1" :max="99"
              incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" v-show="usuarioValido" />
            <label for="calcularCoutas" class="text-sm font-medium text-gray-700"> Calcular Coutas: </label>
            <div class="sm:inline-flex text-gray-900 bg-white border border-gray-200 rounded-lg" id="calcularCoutas"> $
              {{ (importe / cuotas).toFixed(2) }}</div>
            <br />
            <br />
            <h4>Habilitar más de 24 cuotas</h4>
            <ToggleButton v-model="masOcho" onLabel="Si" offLabel="No" onIcon="pi pi-check" offIcon="pi pi-times"
              class="p-button-sm" aria-label="Confirmation" @change="habilitarMasCuotas" />
          </div>
        </div>
        <br />
        <div v-show="habilitarCoutas">
          <div class="col-span-6 sm:col-span-3">
            <label for="Usuario" class=" text-sm font-medium text-gray-700"> Usuario: </label>
            <InputText inputId="Usuario" type="text" v-model="usuario" />
            <label for="Contraseña" class=" text-sm font-medium text-gray-700"> Contraseña: </label>
            <Password v-model="contrasena" toggleMask :feedback="false"></Password>
            <Button label="Validar" icon="pi pi-check" class="p-button-sm" @click="validarUsuario()" />
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <div class="col-span-6 sm:col-span-3">
            <label for="Observaciones" class="block text-sm font-medium text-gray-700">Observaciones</label>
            <InputText inputId="Observaciones" type="text" v-model="obs" class="w-full" />
          </div>
          <div class="col-span-6">
            <div class="w-full text-gray-900 bg-white border border-gray-200 rounded-lg ">
              <div
                class="sm:flex sm:items-center sm:justify-between w-full px-4 py-2 text-sm border-b border-gray-200 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700">
                <div class="font-bold">Subtotal:</div>
                <div class="sm:flex"> $ {{ (importe / cuotas).toFixed(2) }}</div>
              </div>
              <div
                class="sm:flex sm:items-center sm:justify-between w-full px-4 py-2 text-sm border-b border-gray-200 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700">
                <div class="font-bold">Cuotas:</div>
                <div class="sm:flex"> {{ cuotas.toFixed(2) }}</div>
              </div>
              <div
                class="sm:flex sm:items-center sm:justify-between w-full px-4 py-2 text-sm bg-indigo-100 border-b border-indigo-500 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700">
                <div class="font-bold">TOTAL:</div>
                <div class="sm:flex"> $ {{ (importe).toFixed(2) }}</div>
              </div>
            </div>
          </div>

          <div class="col-span-6 justify-self-end">
            <Button label="Grabar" icon="pi pi-check" class="p-button-sm" @click="save" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
  </div>
</template>
<script>
//inicio copiado
import { ref, onMounted, reactive, watch } from 'vue';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import ToggleButton from 'primevue/togglebutton';
import InlineMessage from 'primevue/inlinemessage';
import Password from 'primevue/password';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import moment from 'moment';
import WService from '@/plugins/ws';
import { object, number } from "yup";
import { Input } from 'postcss';

export default {
  components: {
    Dropdown, Calendar, InputNumber, InputText, Button, InlineMessage, ToggleButton, Password, Toast,
  },
  props: {
    idAfiliado: Number,
    idEmpresa: Number
  },
  emits: ["save"],
  setup(props, { emit }) {
    //funcion para obtener fechas de vencimiento
    const obtenerFechaVencimiento = async () => {
      try {
        var per = moment(periodo.value).format('YYYYMM');
        const info = await wService.value.getMethod('Comprobantes/FechasVencimiento/' + per);
        return info;

      } catch (error) {
        console.error('Error al obtener la fecha de vencimiento:', error);
      }
    };

    onMounted(async () => {
      // Obtener las fechas de vencimiento al iniciar la página
      const fechas = await obtenerFechaVencimiento();

      // Asignar las fechas de vencimiento formateadas al iniciar la página
      fechaVencimiento1.value = moment(fechas.vencimiento_1_Original).format('DD/MM/YYYY');
      fechaVencimiento2.value = moment(fechas.vencimiento_2_Original).format('DD/MM/YYYY');

      let param = props.idEmpresa == 0 ? 0 : 1;
      wService.value.getMethod('Comprobantes/Movimiento/' + param).then(info => {
        movimientos.value = info;
        loading.value = false;
      }).catch(err => {
        console.log(err.message);
        loading.value = false;
      });
    });


    const wService = ref(new WService());
    const toast = useToast();
    const idDetalle = ref();
    const selectedDetalle = ref([]);
    const errors = ref({});
    const detalle = reactive({
      idDetalle: 0,
      cuotas: false,
      consultaValorCuota: false,
      detalleNombre: ''
    });
    const date = new Date();
    const periodo = ref(date);
    const importe = ref(0);
    const cuotas = ref(1);
    const obs = ref("");
    const ocularImporte = ref();
    const ocultarCuotas = ref();
    const habilitarCoutas = ref(false);
    const usuario = ref();
    const contrasena = ref();
    const usuarioValido = ref(false);
    const masOcho = ref(false);
    const movimientos = ref([]);
    const fechaVencimiento1 = ref('');
    const fechaVencimiento2 = ref('');
    const mensajeAdvertencia1 = ref(false);
    const mensajeAdvertencia2 = ref(false);
    const cambioManual = ref(false);
    const loading = ref(true);
    //Esquema de validaci�n.
    const schemaSave = object().shape({
      importe: number().required("Debe ingresar un importe")
        .positive("El importe debe ser positivo"),
    });

    //asigna a reactive el valor que se seleccion�
    const completeInfo = () => {
      //loading.value = true;
      let encontro = buscarMovimiento();
      Object.assign(detalle, encontro);
      if (detalle.consultaValorCuota) {
        getImporte(periodo.value);
      }
      let v = movimientos.value[0].detalle.filter(a => a.idDetalle == idDetalle.value);
      if (v.length != 0) {
        if (v[0].consultaValorCuota) {
          ocularImporte.value = true;
          ocultarCuotas.value = false;
        } else {
          if (v[0].ordenesOnline) {
            ocularImporte.value = false;
            ocultarCuotas.value = false;
          } else {
            if (v[0].cuotas) {
              ocularImporte.value = true;
              ocultarCuotas.value = true;
            } else {
              ocularImporte.value = true;
              ocultarCuotas.value = false;
            }
          }
        }
      } else {
        ocularImporte.value = true;
        ocultarCuotas.value = false;
      }
    }

    //trae el importe de factura cuota
    const getImporte = (woPeriodo) => {
      loading.value = true;
      let periodoF = moment(woPeriodo).format("YYYYMM");
      let id = 0;
      if (props.idEmpresa == 0) {
        id = props.idAfiliado;
        wService.value.getMethodWithParam(`Comprobantes/Cuota/${id}/${periodoF}/`).then(info => {
          importe.value = info[0].valorCuota;
          loading.value = false;
        }).catch(err => {
          console.log(err.message);
          loading.value = false;
        });
      } else {
        id = props.idEmpresa
        wService.value.getMethodWithParam(`Comprobantes/CuotaEmpresa/${id}/${periodoF}/`).then(info => {
          importe.value = info[0].valorCuota;
          loading.value = false;
        }).catch(err => {
          console.log(err.message);
          loading.value = false;
        });
      }
      loading.value = false;
    }

    //funcion interna para buscar el movimiento seleccionado
    const buscarMovimiento = () => {
      var BreakException = {};
      let encontro = {};
      try {
        movimientos.value.forEach((mov) => {
          mov.detalle.forEach((det) => {
            if (det.idDetalle === idDetalle.value) {
              encontro = det;
              throw BreakException
            }
          })
        });
      }
      catch (e) {
        if (e !== BreakException) throw e;
      }

      return encontro;
    }

    //funcion para habilitar mas de 8 cuotas
    const habilitarMasCuotas = () => {

      if (habilitarCoutas.value) {
        habilitarCoutas.value = false;
        usuarioValido.value = false;
      } else {
        habilitarCoutas.value = true;
        cuotas.value = 1;
      }
    }

    //funcion para chequear usuario para agregar cuotas
    const validarUsuario = () => {
      wService.value.getMethodWithParam(`Comprobantes/AutenticarUsuarioCuota/${usuario.value}/${contrasena.value}/`).then(info => {
        //console.log(info.value, info)
        if (info == "Ok") {
          cuotas.max = 100;
          habilitarCoutas.value = true;
          usuarioValido.value = true;
          toast.add({ severity: 'success', summary: 'Mensaje exitoso', detail: 'Cuotas habilitadas', life: 3000 });
        } else {
          toast.add({ severity: 'error', summary: 'Error', detail: 'Error al habilitar', life: 3000 });
        }
      }).catch(err => {
        console.log(err.message);
        loading.value = false;
      });
    }

    const save = () => {
    if(props.idEmpresa == 0){
      loading.value = true;
      schemaSave.validate({ importe: importe.value }, { abortEarly: false }).then(() => {
        let comprobante = {
          idComprobante: 0,
          idAfiliado: props.idAfiliado,
          idCajaTipoOrigen: 0,
          numero: '',
          cuotas: cuotas.value,
          importe: importe.value,
          codigoBarra: '',
          idTipoMovimiento: 1,
          idDetalle: idDetalle.value,
          detalle: obs.value,
          idEmpresa: null,
          periodo: moment(periodo.value).format("YYYYMM"),
          anulado: false,
          Vencimiento_1_Original: moment(fechaVencimiento1.value, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD'),
          Vencimiento_2_Original: moment(fechaVencimiento2.value, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD'),
        };
        //console.log(comprobante);
        wService.value.postMethod("Comprobantes/", comprobante, "").then(info => {
          loading.value = false;
          emit("save", info);
        }).catch(err => {
          console.log(err.message);
          loading.value = false;
        });
      })
        .catch(err => {
          loading.value = false;
          err.inner.forEach(error => {
            errors.value[error.path] = error.message;
          });
        });
    }else{
      loading.value = true;
      schemaSave.validate({ importe: importe.value }, { abortEarly: false }).then(() => {
        let comprobante = {
          idComprobante: 0,
          idAfiliado: props.idAfiliado,
          idCajaTipoOrigen: 0,
          numero: '',
          cuotas: cuotas.value,
          importe: importe.value,
          codigoBarra: '',
          idTipoMovimiento: 1,
          idDetalle: idDetalle.value,
          detalle: obs.value,
          idEmpresa: props.idEmpresa,
          periodo: moment(periodo.value).format("YYYYMM"),
          anulado: false,
          Vencimiento_1_Original: moment(fechaVencimiento1.value, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD'),
          Vencimiento_2_Original: moment(fechaVencimiento2.value, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD'),
        };
        wService.value.postMethod("Comprobantes/ComprobanteEmpresa/", comprobante, "").then(info => {
          loading.value = false;
          emit("save", info);
        }).catch(err => {
          console.log(err.message);
          loading.value = false;
        });
      })
        .catch(err => {
          loading.value = false;
          err.inner.forEach(error => {
            errors.value[error.path] = error.message;
          });
        });
    }    
    }
    const handleManualChange = () => {
      cambioManual.value = true;
      obtenerFechaVencimiento()
        .then(fechas => {
          // Guardar los valores anteriores de las fechas de vencimiento
          const oldFechaVencimiento1 = moment(fechaVencimiento1.value).format('YYYY-MM-DD');
          const oldFechaVencimiento2 = moment(fechaVencimiento2.value).format('YYYY-MM-DD');

          // Verificar si las fechas han cambiado y actualizar el mensaje de advertencia si es necesario
          if (oldFechaVencimiento1 == moment(fechas.vencimiento_1_Original).format('YYYY-MM-DD')) {
            cambioManual.value = false;
            mensajeAdvertencia1.value = false;
          }
          if (oldFechaVencimiento2 == moment(fechas.vencimiento_2_Original).format('YYYY-MM-DD')) {
            cambioManual.value = false;
            mensajeAdvertencia2.value = false;
          }
        })
        .catch(error => {
          console.error('Error al obtener las fechas de vencimiento:', error);
        });
    };


    watch(fechaVencimiento1, () => {
      if (cambioManual.value) {
        mensajeAdvertencia1.value = true;
        cambioManual.value = false;
      } else {
        mensajeAdvertencia1.value = false;
      }
    });

    watch(fechaVencimiento2, () => {
      if (cambioManual.value) {
        mensajeAdvertencia2.value = true;
        cambioManual.value = false;
      } else {
        mensajeAdvertencia2.value = false;
      }
    });


    // Función para manejar el cambio del periodo
    watch(periodo, async (newValue, oldValue) => {
      getImporte(newValue);
      if (newValue !== oldValue) {
        // Obtener las fechas de vencimiento
        const fechas = await obtenerFechaVencimiento();

        // Restablecer la bandera a false después del cambio automático
        cambioManual.value = false;

        // Asignar las fechas de vencimiento formateadas
        fechaVencimiento1.value = moment(fechas.vencimiento_1_Original).format('DD/MM/YYYY');
        fechaVencimiento2.value = moment(fechas.vencimiento_2_Original).format('DD/MM/YYYY');
      }
    });


    return {
      idDetalle, errors, periodo, importe, cuotas, obs,
      loading, movimientos, detalle, ocularImporte, ocultarCuotas, masOcho, habilitarCoutas,
      usuario, contrasena, usuarioValido, fechaVencimiento1, fechaVencimiento2, mensajeAdvertencia1, mensajeAdvertencia2, cambioManual,

      completeInfo, save, habilitarMasCuotas, validarUsuario, handleManualChange,
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Color del borde */
  border-left-color: rgb(19 34 139); /* Color de la primera parte del borde (azul) */
  border-radius: 50%; /* Borde redondeado */
  width: 40px; /* Tamaño del spinner */
  height: 40px; /* Tamaño del spinner */
  animation: spin 1s linear infinite; /* Animación de rotación */
}

/* Animación de rotación */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>